<div *ngIf="product" class="container">
    <h3 mat-dialog-title>{{product.nombre}}</h3>
    <h6 mat-dialog-subtitle>Categoria <span class="text-primary">{{product.categoria?.nombre}}</span></h6>
    <mat-divider class="my-3"></mat-divider>
    <mat-dialog-content>
        <p>Descripción:<br>
            {{product.descripcion}}
        </p>
        <h5>
            <span class="text-danger">Costo: {{product.costo | currency : '$'}} |</span>
            <span class="text-success"> Precio: {{product.precio | currency : '$'}}</span>
        </h5>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-raised-button color="primary" [routerLink]="['/editar-producto', product._id]">
            <mat-icon>edit</mat-icon> Editar
        </button>
        <button mat-raised-button color="accent" (click)="deleteProduct(product._id)">
            <mat-icon>delete</mat-icon> Borrar
        </button>
    </mat-dialog-actions>
</div>